import { PageError, SystemActionTypes } from './types';

export type AppState = Readonly<{
  appName: string;
  isLoading: boolean;
  isMobile: boolean;
  error?: PageError;
  recaptchaToken: string;
}>;

export const initialState: AppState = {
  appName: '',
  isLoading: false,
  isMobile: false,
  error: null,
  recaptchaToken: null,
};

export const appReducer = (state: AppState = initialState, action: SystemActionTypes): AppState => {
  switch (action.type) {
    case 'APP_DISABLE_LOADING': {
      return {
        ...state,
        isLoading: false,
      };
    }
    case 'APP_ENABLE_LOADING': {
      return {
        ...state,
        isLoading: true,
      };
    }
    case 'SET_IS_MOBILE': {
      return {
        ...state,
        isMobile: action.payload,
      };
    }
    case 'SET_PAGE_ERROR': {
      return {
        ...state,
        error: action.payload,
      };
    }
    case 'CLEAN_PAGE_ERROR': {
      return {
        ...state,
        error: null,
      };
    }
    case 'SET_RECAPTCHA_TOKEN': {
      return {
        ...state,
        recaptchaToken: action.payload,
      };
    }
    default:
      return state;
  }
};
